<template>
  <div class="account-lock-content">
    <Text
      :variant="'16'"
      color="t1"
      v-if="isMobile"
      :weight="'medium'"
      class="account-lock-content-title"
    >
      {{ $t('zhang-hao-yi-suo-ding') }}
    </Text>
    <p class="account-lock-content-info">
      <Text :variant="'14'" color="t5">
        {{
          $t(
            'bao-qian-nin-shu-ru-de-mi-ma-cuo-wu-ci-shu-guo-duo-zhang-hao-yi-bei-suo-ding-qing-left-hou-zhong-shi',
            [left],
          )
        }}
      </Text>
    </p>
    <p class="account-lock-content-info">
      <Text :variant="'14'" color="t5">
        {{ $t('nin-ke-yi-chang-shi') }}
      </Text>
      <Text @click="handleFindPassword" :color="'p6'" :variant="'14'">
        {{ $t('zhao-hui-mi-ma') }}
      </Text>
      <template v-if="isChinese() && !isMobile">
        <Text :variant="'14'" color="t5">
          {{ $t('huo') }}
        </Text>
        <Text @click="handleUseWechatLogin" :color="'p6'" :variant="'14'">
          {{ $t('shi-yong-wei-xin-deng-lu') }}
        </Text>
      </template>
    </p>
    <div class="footer">
      <Button @click="close" :blank="isMobile" :size="isMobile ? 'large' : 'default'">
        {{ $t('wo-zhi-dao-le') }}
      </Button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { BottomDrawerInstance } from '@rendora/common/features/bottom-drawer/factory';
import type { ModalInstance } from '@rendora/common/features/modals/factory';
import { Button } from '@rendora/design/components/button';
import { Text } from '@rendora/design/components/text';
import { useBreakpoint } from '@rendora/design/index';
import dayjs from 'dayjs';
import { useI18n } from 'vue-i18n';
import { isChinese } from '~/utils/area';
import { emitter, EVENT } from '~/utils/eventbus';

const headers = useRequestHeaders();
const { isMobile } = useBreakpoint(headers?.['user-agent']);
const { t: $t } = useI18n();

const modalInstance = inject<ModalInstance>('modalInstance')!;
const bottomDrawerInstance = inject<BottomDrawerInstance>('bottomDrawerInstance')!;

const close = () => {
  if (isMobile.value) {
    bottomDrawerInstance.close();
  } else {
    modalInstance.close();
  }
};

const props = defineProps<{ data: any; onCancel: any; i18n: any }>();

const left = computed(() => {
  const t = dayjs.duration(props.data.expired_time * 1000);
  let str = $t('dminutes-fen-zhong', [t.minutes()]);
  if (t.seconds() > 0) {
    str += $t('dseconds-miao', [t.seconds()]);
  }
  return str;
});

function handleFindPassword() {
  emitter.emit(EVENT.FIND_PWD);
  close();
}

function handleUseWechatLogin() {
  emitter.emit(EVENT.SWITCH_WECHAT_LOGIN);
  close();
}
</script>

<style lang="scss" scoped>
@use '@rendora/design/styles/mixins.scss' as *;

.account-lock-content-title {
  margin-bottom: 16px;

  @include mobile {
    margin-bottom: responsive-size(16px);
  }
}

.account-lock-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  @include mobile {
    padding: responsive-size(20px);
  }
}

.account-lock-content-info {
  display: flex;
  gap: 4px;

  @include mobile {
    gap: responsive-size(4px);
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @include mobile {
    margin-top: responsive-size(48px);
  }
}
</style>
